(function() {
    'use strict';

    angular.module("settings")
        .controller('VariableListController', VariableListController);

    VariableListController.$inject = ['datatableDefaultPageSizeValueConst', 'variableDataSrvc', 'searchFilterSrvc', 'notificationSrvc', 'lodashService', 'variableMessagesConst', 'variableSrvc', 'checkSearchSrvc', 'variablePermissionsConst', 'filterQuerySrvc'];

    function VariableListController(datatableDefaultPageSizeValueConst, variableDataSrvc, searchFilterSrvc, notificationSrvc, lodashService, variableMessagesConst, variableSrvc, checkSearchSrvc, variablePermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.variableRows = [];
        self.variableCols = [{
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true,
            isEditable: true
        }, {
            title: 'Wartość',
            value: 'value',
            type: 'boolean',
            searchable: true,
            orderable: true,
            isEditable: true
        }];
        self.modelPermissions = variablePermissionsConst;

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.searchQuery = {
            name: null,
            value: null,
            ordering: null
        };

        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getVariables();
        }

        function getVariables(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    name: self.searchQuery.name,
                    value: searchFilterSrvc.getCheckboxFilterValue(self.searchQuery.value),
                    ordering: self.searchQuery.ordering
                };
            }
            return variableDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.variableRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getVariables);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onEdit(row, isNewRow) {
            row.value = !!row.value;
            if (isNewRow) {
                delete row.pk;
                return variableDataSrvc.create(row);
            } else {
                return variableDataSrvc.update({
                    pk: row.pk
                }, row);
            }
        }

        function onDelete(row) {
            return variableSrvc.remove(row.name, row.pk,
                function(response) {
                    removeVariableRow(row);
                    return response;
                },
                function(error) {
                    if (error.status === 404) {
                        removeVariableRow(row);
                    }
                });
        }

        function removeVariableRow(row) {
            notificationSrvc.notification("success", variableMessagesConst.delete);
            return lodashService.remove(self.variableRows, { pk: row.pk });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getVariables();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getVariables();
        }
    }
})();
